import React from 'react';
import { Stepper, Step, StepLabel, } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTranslation } from 'react-i18next';
const ProgressSteps = ({ activeStep, steps }) => {
  const { t } = useTranslation();
  const matches = useMediaQuery("(min-width:600px)");

  return (
    <>
    {matches &&
    <Stepper activeStep={activeStep} sx={{marginBottom:"2rem",}} alternativeLabel>
      {steps.map((label) => (
        <Step key={label}>

          <StepLabel></StepLabel>
        </Step>
      ))}
    </Stepper>
      }
      </>
  );
};

export default ProgressSteps;